import Image from 'next/image'
import {FC} from 'react'

import {GetStartedBanner} from '@/components/common/banner/GetStartedBanner'
import {ButtonVariant} from '@/components/common/content/ButtonTypes'
import {TextFontWeight, TextVariant} from '@/components/common/content/Text'
import {ArrowIcon} from '@/components/common/icons/ArrowIcon'
import {getSpecimenGuideContent} from '@/content/specimenGuide'
import {useTranslation} from '@/i18n'
import {theme} from '@/theme/theme'
import {
  MOBILE_SCREENSIZE,
  TABLET_SCREENSIZE,
  USER_TABLET_SCREENSIZE,
} from '@/utils/styles/breakpoints'

export const SpecimenGuideBanner: FC = () => {
  const {t} = useTranslation()
  const {title, description, imageSrc, imageAlt, registration, sou, dou} =
    getSpecimenGuideContent().ctaBanner

  return (
    <>
      <GetStartedBanner
        title={t(title)}
        titleVariant={TextVariant.h3}
        description={t(description)}
        buttons={[
          {
            linkHref: registration.linkHref,
            text: t(registration.linkText),
            variant: ButtonVariant.default,
            icon: <ArrowIcon />,
            fontWeight: TextFontWeight.medium,
            trackedEvent: {
              name: `${registration.trackedEventName} (Specimen guide - Get started banner)`,
            },
          },
          {
            linkHref: sou.linkHref,
            text: t(sou.linkText),
            variant: ButtonVariant.default,
            icon: <ArrowIcon />,
            fontWeight: TextFontWeight.medium,
            trackedEvent: {
              name: `${sou.trackedEventName} (Specimen guide - Get started banner)`,
            },
          },
          {
            linkHref: dou.linkHref,
            text: t(dou.linkText),
            variant: ButtonVariant.default,
            icon: <ArrowIcon />,
            fontWeight: TextFontWeight.medium,
            trackedEvent: {
              name: `${dou.trackedEventName} (Specimen guide - Get started banner)`,
            },
          },
        ]}
      >
        <div className="image">
          <Image src={imageSrc} alt={imageAlt} sizes="220px" fill style={{objectFit: 'contain'}} />
        </div>
      </GetStartedBanner>

      <style jsx>{`
        .image {
          position: relative;
          width: 220px;
          height: 230px;
          margin-right: ${theme.spacing[7]};
        }
        @media ${TABLET_SCREENSIZE} {
          .image {
            margin-left: ${theme.spacing[8]};
            margin-right: ${theme.spacing[4]};
          }
        }
        @media ${USER_TABLET_SCREENSIZE} {
          .image {
            margin-left: 0;
            margin-right: -${theme.spacing[8]};
            margin-top: ${theme.spacing[6]};
          }
        }
        @media ${MOBILE_SCREENSIZE} {
          .image {
            height: 160px;
            margin-right: -${theme.spacing[4]};
          }
        }
      `}</style>
    </>
  )
}
